const { asyncRoute } = require('@nike/vega');
const {
  composed: composedPDP,
  routes: pdpRoutes,
} = require('@nike/pagelet-pdp');
const {
  routes: wallRoutes,
} = require('@nike/pagelet-wall');

const defaultRoute = {
  id: 'App Default',
  path: '/',
  component: asyncRoute(
    /* webpackChunkName: "pdp" */
    () => composedPDP
  ),
  isExact: true,
};

module.exports = [
  ...pdpRoutes,
  ...wallRoutes,
  defaultRoute,
];



// WEBPACK FOOTER //
// ./src/routes.js